<template>
  <div class="wrapper">
    <Navbar />

    <div class="container">
      <div class="row mt-5">
        <div class="col col-lg-8 offset-lg-2">
          <div class="card">
            <div class="card-body text-center">
              <img
                class="my-3"
                src="@/assets/image/email-verified.png"
                alt="email-verified"
              >
              <h4 class="mt-3">
                {{ $t('email-verified.title') }}
              </h4>
              <p class="text-secondary px-md-3 px-lg-5 mx-lg-5 mb-5 pb-5">
                {{ $t('email-verified.thanks') }}
              </p>
              <router-link
                class="btn btn-info mt-5 mb-3 px-3 py-2"
                to="/"
              >
                {{ $t('email-verified.back') }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'

export default {
  components: {
    Navbar
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  background-color: #f5efff;
  background-image: url("../assets/image/bg-2.png");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
  min-height: 100vh;
}

.card {
  border: 0;
  border-radius: 18px;
}

.btn {
  font-size: 12px;
}
</style>
